import {
    filter,
    findIndex,
    join,
    map,
    replace,
    slice,
    split,
    startCase,
    startsWith,
    trim,
    trimStart,
    truncate,
} from 'lodash';

export const tokensToString = (tokens: string[]) => {
    return map(tokens, (token: string) => startCase(replace(token, '-', ' ')));
};

export const getTokens = (path: string) => {
    const trimmedPath = trim(path, '/');
    return split(trimmedPath, '/');
};

export const pathToAlgoliaHierarchy = (path: string) => {
    const tokens = tokensToString(getTokens(path));
    const nestedLevel = tokens.length - 1;
    return `categories.lvl${nestedLevel}: ` + tokens.join(' > ');
};

export const hierarchyToTokens = (hierarchy: { [key: number]: string }) => {
    return map(hierarchy, (value) => value);
};

export const amountToString = (value: number, currency: string) => {
    return `${value.toLocaleString('en-US')} ${currency}`;
};

export const stripHTMLFromString = (htmlString: string) => {
    return htmlString.replace(/(<([^>]+)>)/gi, '');
};

type tokensToPageTitleProps = {
    tokens: (string | undefined)[];
    separator?: string;
};
export const tokensToPageTitle = ({ tokens, separator = ' | ' }: tokensToPageTitleProps) => {
    const limit = [40, 15, 10];
    const truncatedTokens = tokens
        .filter((token) => token !== '' && token !== undefined)
        .map((token, index) =>
            truncate(token, {
                length: limit[index],
                separator: ' ',
                omission: '...',
            }),
        );
    return truncatedTokens.join(separator);
};

type UrlPathToSegmentPageNameProps = {
    path: string;
    language: string;
};

export const urlPathToSegmentPageName = ({ path, language }: UrlPathToSegmentPageNameProps) => {
    const pathStr = trimStart(path, language + '/');
    const tokens = split(pathStr, '/').map((el) => {
        if (startsWith(el, '_')) {
            return trimStart(el, '_');
        } else {
            return startCase(el);
        }
    });
    return join(tokens, ': ');
};

export const getCategoriesFromPath = (url: string) => {
    const urlObject = new URL(url);
    const tokens = split(urlObject.pathname, '/');
    const buyIndex = findIndex(tokens, (i) => i === 'buy');
    const strippedTokens = slice(tokens, buyIndex + 1);
    return filter(strippedTokens, (token) => token[0] !== '_');
};
